const DEFAULT = 'DEFAULT';
const VARIANT = 'VARIANT';
export const PersonalizationVariantStatuses = {
  DEFAULT,
  VARIANT
};